import type {Frequency, Tier} from "./pricing-types";

import {FrequencyEnum, TiersEnum} from "./pricing-types";

/** 完整功能对比表表头（不含企业版；初创版在成长版左侧） */
export const pricingComparisonTiers: Array<{key: TiersEnum; title: string}> = [
  // {key: TiersEnum.Startup, title: "初创版"},
  {key: TiersEnum.Free, title: "成长版"},
  {key: TiersEnum.Pro, title: "专业版"},
  {key: TiersEnum.Team, title: "商业版"},
];

export const frequencies: Array<Frequency> = [
  {key: FrequencyEnum.Yearly, label: "年付", priceSuffix: "年"},
  {key: FrequencyEnum.Quarterly, label: "月付", priceSuffix: "月"},
];

export const tiers: Array<Tier> = [
  // {
  //   key: TiersEnum.Startup,
  //   title: "初创版",
  //   description: "适合创业者、主理人使用，完成夜间流量的接待。",
  //   price: {
  //     [FrequencyEnum.Yearly]: "￥1,980",
  //     [FrequencyEnum.Quarterly]: "￥198",
  //   },
  //   href: "/signup",
  //   featured: false,
  //   mostPopular: false,
  //   features: [
  //     "月消息收发量 1,000",
  //     "无限账号",
  //     "AI 技能",
  //     "50 知识单元",
  //     "MCP",
  //     "官网/个微/微信客服",
  //   ],
  //   buttonText: "免费试用",
  //   buttonColor: "default",
  //   buttonVariant: "flat",
  // },
  {
    key: TiersEnum.Free,
    title: "成长版",
    price: {
      [FrequencyEnum.Yearly]: "￥9,800",
      [FrequencyEnum.Quarterly]: "$24",
    },
    href: "/signup",
    featured: false,
    mostPopular: false,
    description: "适合个人工作室或初创品牌，专注于低成本实现抖音、小红书公域流量的自动获客与截流。",
    features: [
      "月消息收发量 6,000",
      "无限账号",
      "AI 技能",
      "50 知识单元",
      "MCP",
      "官网/抖音/小红书",
    ],
    buttonText: "免费试用",
    buttonColor: "default",
    buttonVariant: "flat",
  },
  {
    key: TiersEnum.Pro,
    title: "专业版",
    description: "适合成长期私域团队，刚需打通微信/企微生态闭环，并开始注重品牌形象的规范化建设",
    href: "/signup",
    mostPopular: false,
    price: {
      [FrequencyEnum.Yearly]: "￥29,800",
      [FrequencyEnum.Quarterly]: "$24",
    },
    featured: false,
    features: [
      "月消息收发量 20,000",
      "成长版所有功能",
      "500 知识单元",
      "AI 介入策略",
      "品牌自定义",
      "微信私域/WhatsApp",
      "上线配置指导",
    ],
    buttonText: "免费试用",
    buttonColor: "default",
    buttonVariant: "flat",
  },
  {
    key: TiersEnum.Team,
    title: "商业版",
    href: "/signup",
    featured: true,
    mostPopular: false,
    description: "适合中型企业，依赖专家级交付服务(保姆式落地)，且需永久沉淀客户数据资产",
    price: {
      [FrequencyEnum.Yearly]: "￥59,800",
      [FrequencyEnum.Quarterly]: "$120",
    },
    features: [
      "月消息收发量 50,000",
      "专业版所有功能",
      "5,000 知识单元",
      "永久消息保留",
      "自定义流量包",
      "海外社媒",
      "40 工时指导",
     
    ],
    buttonText: "免费试用",
    buttonColor: "default",
    buttonVariant: "flat",
  },
  {
    key: TiersEnum.Customer,
    title: "企业版",
    href: "/signup",
    featured: true,
    mostPopular: false,
    description: "适合大型集团或合规企业，对数据私有化、SSO单点登录及系统稳定性(SLA)有严格的审计级要求",
    price: "个性化",
    features: [
      "月消息收发量 100,000+",
      "商业版所有功能",
      "无限知识库",
      "个性化消息流量",
      "个性化指导",
      "99.9% SLA",
     
    ],
    buttonText: "免费试用",
    buttonColor: "default",
    buttonVariant: "flat",
  },
  // {
  //   key: TiersEnum.Customer,
  //   title: "企业版",
  //   href: "/signup",
  //   featured: true,
  //   mostPopular: false,
  //   description: "适合大型集团或合规企业，对数据私有化、SSO单点登录及系统稳定性(SLA)有严格的审计级要求",
  //   price: {
  //     [FrequencyEnum.Yearly]: "个性化",
  //     [FrequencyEnum.Quarterly]: "个性化",
  //   },
  //   features: [
  //     "月消息收发量 100,000+",
  //     "商业版所有功能",
  //     "无限知识库",
  //     "个性化消息流量",
  //     "个性化指导",
  //     "99.9% SLA",

  //   ],
  //   buttonText: "联系我们",
  //   buttonColor: "default",
  //   buttonVariant: "flat",
  // },
];
